import Store from 'app/store'
import Vue from "vue"
import Router from 'offline/router'

import subdomains from './../router/subdomains.js'
import externaldomains from './../router/externaldomains.js'
import $templates from './../components/common/view/templates'

function getView(skipFilter) {

	skipFilter = skipFilter || false

	if(!this.$currentViewContext) return false

    var value = this.$store.getters['filter/config/' + this.$currentViewContext + '/layout']
    var view = false
				
	var context_id = 0

	if(this.$currentViewContext === 'collection') context_id = 1;
	if(this.$currentViewContext === 'ratings') context_id = 2;
	if(this.$currentViewContext === 'plays') context_id = 3;
	if(this.$currentViewContext === 'gameplays') context_id = 4;

    if(!this.$_.contains(['list', 'grid', 'sheet', 'gallery'], value) && value) {

        view = this.$store.getters['data/views'][value]

        if(!view) value = false

    }

	// Profile config takes priority over the per-view default flag.
	// Why: defallt.php keeps both in sync on every Set Default save
	// (config layout + view_default), so when they agree either source
	// resolves to the same view. When they DISAGREE the config layout
	// reflects the user's most recent explicit choice — preferring it
	// recovers gracefully from legacy data where a stale view_default
	// flag was left behind by older save paths and now points at a
	// different view than what the user thinks is their default.
	if(this.$store.getters['context/config']) {

		if(!value && !view && this.$store.getters['context/config'][this.$currentViewContext].layout) {

			var configView = this.$store.getters['context/config'][this.$currentViewContext].layout

			if(this.$_.contains(['list','sheet','grid','gallery'], configView)) {

				view = $templates[this.$currentContextType][this.$currentViewContext][configView]

				if(!skipFilter) this.$store.commit('filter/config/' + this.$currentViewContext + '/layout', configView)

			} else {

				view = this.$_.findWhere(this.$store.getters['data/views/list'], {
					context: context_id,
					id: this.$store.getters['context/config'][this.$currentViewContext].layout
				})

				if(view && !skipFilter) this.$store.commit('filter/config/' + this.$currentViewContext + '/layout', view.id)

			}

		}

	}

	// if not then get context default
	if(!value && !view) {

		value = $templates[this.$currentContextType][this.$currentViewContext].default

		if(!skipFilter) this.$store.commit('filter/config/' + this.$currentViewContext + '/layout', value)

	}

    if(!view) view = $templates[this.$currentContextType][this.$currentViewContext][value]

	return view

}

export default {

	computed: {

		$currentContextType: function() {

			if (this.isUser) return 'user'
			if (this.isGroup) return 'group'
			if (this.isBuddies) return 'buddies'

			return false

		},

		$currentViewType: function() {

			if (!this.currentView) return false

			if (this.currentView.type === 1) return 'list'
			if (this.currentView.type === 2) return 'sheet'
			if (this.currentView.type === 3) return 'grid'
			if (this.currentView.type === 4) return 'gallery'

			return false

		},

		$currentViewContext: function() {

			if(this.$_.isFunction(this.$route.meta.hasViews)) {

				return this.$route.meta.hasViews.call(this)

			} else {

				return this.$route.meta.hasViews || false

			}

		},

		$currentView: function() {

			return getView.call(this)

		},

		$checkView: function() {

			return getView.call(this, true)

		},

		$isViewSheet: function() {

			var view = this.$checkView

            if (view) {

                return view.type === 2

            } else {

				return false

			}

		},

		$isViewList: function() {

			var view = this.$checkView

            if (view) {

                return view.type === 1

            } else {

				return false

			}

		},

		$offlineRouting: function() {

			var forced = !!this.$CONSTANTS.OFFLINE.FORCE
			var enabled = !!this.$CONSTANTS.OFFLINE.LOCAL
			var connected = !!Router.connected
			var offline = forced || !connected
			var mode = offline ? 'offline' : (enabled ? 'local' : 'online')

			return {
				forced: forced,
				enabled: enabled,
				connected: connected,
				offline: offline,
				online: !offline,
				active: offline || enabled,
				mode: mode
			}

		},

		$isOfflineRouting: function() {

			return this.$offlineRouting.offline

		},

		$canOfflineRoute: function() {

			return this.$offlineRouting.active

		},

        $subdomain: function() {

			var host = false

            if (process.env.VUE_APP_TYPE === 'externaldomain') {

				var externaldomain = false
                    
              	host = window.location.hostname

               	externaldomain = host

                if(externaldomains[externaldomain]) {

                    return externaldomains[externaldomain]

                } else {

                    return false

                }

            } else if (process.env.VUE_APP_TYPE === 'subdomain') {

				var subdomain = false
                    
               	host = window.location.hostname
                var parts = host.split('.')

                if (parts.length > 2) {
                    subdomain = parts[0].toLowerCase()
                }

				if (process.env.VUE_APP_ENV === 'development') {

					subdomain = 'binder'

				}

                if(subdomains[subdomain]) {

                    return subdomains[subdomain]

                } else {

                    return false

                }

            } else {

                return false

            }

        },

		$isDesktop: function() {

			return this.window.is.desktop || this.window.is.smalldesktop

		},

		$isSmallDesktop: function() {

			return this.window.is.smalldesktop

		},

		$isMobile: function() {

			return this.window.is.mobile

		},

		$path: function() {

			console.log(this.$route.path)
			return this.$route.path

		},

		isProfile: function() {

			return this.$route.name !== 'Home'

		},

		isSelf: function() {

			return this.$isSelf

		},

		$isSelf: function() {

			return (Store.getters['session/user/id'] === Store.getters['context/id']) && Store.getters['context/is/user']

		},

		isUser: function() {

			return Store.getters['context/is/user']

		},

		isGroup: function() {

			return Store.getters['context/is/group']

		},

		isBuddies: function() {

			return Store.getters['context/is/buddies']

		},

		isGroupOrBuddies: function() {

			return Store.getters['context/is/buddies'] || Store.getters['context/is/group']

		},

		hasMe: function() {

			return Store.getters['permissions/is/member'] || Store.getters['permissions/is/owner']

		},

		isOwner: function() {

			return Store.getters['permissions/is/owner']

		},

		isMember: function() {

			return Store.getters['permissions/is/member']

		},

		loggedin: function() {

			return Store.getters['session/loggedin']

		},

		$loggedin: function() {

			return Store.getters['session/loggedin']

		},

		$isPatreon: function() {

			return (this.$loggedin) ? Store.getters['session/patreon'] : false

		}

	},

	methods: {

		$vueset: function(a, b, c) {

			Vue.set(a, b, c)

		},

		$vueremove: function(a, b) {

			Vue.delete(a, b)

		},

		$hasEarly: function(name) {

			if(this.isUser) {

				return this.$_.contains(Store.getters['context/early'], name)

			} else {

				return false

			}

		},

		$routerPush: function(e) {

            if (process.env.VUE_APP_TYPE === 'subdomain' || process.env.VUE_APP_TYPE === 'externaldomain') {

				if (e.params) {

                    if (e.params.type) {

						if (this.$subdomain.type !== e.params.type || this.$subdomain.name !== e.params.name) {

							window.location.href = 'https://geekgroup.app/' + e.params.type + '/' + e.params.name

						} else {

							this.$router.push(e)

						}

					} else {

						this.$router.push(e)
						
					}

                } else {

                    this.$router.push(e)

                }

			} else {

				this.$router.push(e)

			}

		},

		$notify: function(config) {

			if (this.$_.isArray(config.message)) config.message = config.message.join(' ')

			config.message = config.message.replace(' .', '.')

			Vue.$toast.open(config)

		},

		formatcurrency: function(value, decimals, pure) {

			return this.$options.filters.currency(Math.abs(value), decimals, pure)

		},

		$filter: function(name, value, param) {

			return this.$options.filters[name](value, param)

		}

	}

}
